   <script>
    import {
        Block,
        BlockTitle,
        List,
        ListInput,
        Row,
        Col,
        Button,
        Link,
        Chip,
        Tabs,
        Tab,
        Checkbox
    } from 'framework7-svelte';
    import { onMount } from 'svelte';
    import { getAlertas,getEstados } from '../../../tools/service/general'
    let alerta={
        "nombre":"",
        "apellidos":"",
        "institucion":"",
        "puesto":"",
        "profesion":"",
        "correo":"",
        "correoCheck":"",
        "sel_pais":"México",
        "sel_estado":"Aguascalientes",
        "comentario":"",
        "boletin":""
    }

    $: estadosResult=[
        {
            "id_pais": "1",
            "id_estado": "1-1",
            "nom_estado": "Aguascalientes"
        },
        {
            "id_pais": "1",
            "id_estado": "1-10",
            "nom_estado": "Durango"
        },
        {
            "id_pais": "1",
            "id_estado": "1-11",
            "nom_estado": "Guanajuato"
        },
        {
            "id_pais": "1",
            "id_estado": "1-12",
            "nom_estado": "Guerrero"
        },
        {
            "id_pais": "1",
            "id_estado": "1-13",
            "nom_estado": "Hidalgo"
        },
        {
            "id_pais": "1",
            "id_estado": "1-14",
            "nom_estado": "Jalisco"
        },
        {
            "id_pais": "1",
            "id_estado": "1-15",
            "nom_estado": "México"
        },
        {
            "id_pais": "1",
            "id_estado": "1-16",
            "nom_estado": "Michoacán de Ocampo"
        },
        {
            "id_pais": "1",
            "id_estado": "1-17",
            "nom_estado": "Morelos"
        },
        {
            "id_pais": "1",
            "id_estado": "1-18",
            "nom_estado": "Nayarit"
        },
        {
            "id_pais": "1",
            "id_estado": "1-19",
            "nom_estado": "Nuevo León"
        },
        {
            "id_pais": "1",
            "id_estado": "1-2",
            "nom_estado": "Baja California"
        },
        {
            "id_pais": "1",
            "id_estado": "1-20",
            "nom_estado": "Oaxaca"
        },
        {
            "id_pais": "1",
            "id_estado": "1-21",
            "nom_estado": "Puebla"
        },
        {
            "id_pais": "1",
            "id_estado": "1-22",
            "nom_estado": "Querétaro"
        },
        {
            "id_pais": "1",
            "id_estado": "1-23",
            "nom_estado": "Quintana Roo"
        },
        {
            "id_pais": "1",
            "id_estado": "1-24",
            "nom_estado": "San Luis Potosí"
        },
        {
            "id_pais": "1",
            "id_estado": "1-25",
            "nom_estado": "Sinaloa"
        },
        {
            "id_pais": "1",
            "id_estado": "1-26",
            "nom_estado": "Sonora"
        },
        {
            "id_pais": "1",
            "id_estado": "1-27",
            "nom_estado": "Tabasco"
        },
        {
            "id_pais": "1",
            "id_estado": "1-28",
            "nom_estado": "Tamaulipas"
        },
        {
            "id_pais": "1",
            "id_estado": "1-29",
            "nom_estado": "Tlaxcala"
        },
        {
            "id_pais": "1",
            "id_estado": "1-3",
            "nom_estado": "Baja California Sur"
        },
        {
            "id_pais": "1",
            "id_estado": "1-30",
            "nom_estado": "Veracruz de Ignacio de la Llave"
        },
        {
            "id_pais": "1",
            "id_estado": "1-31",
            "nom_estado": "Yucatán"
        },
        {
            "id_pais": "1",
            "id_estado": "1-32",
            "nom_estado": "Zacatecas"
        },
        {
            "id_pais": "1",
            "id_estado": "1-4",
            "nom_estado": "Campeche"
        },
        {
            "id_pais": "1",
            "id_estado": "1-5",
            "nom_estado": "Coahuila de Zaragoza"
        },
        {
            "id_pais": "1",
            "id_estado": "1-6",
            "nom_estado": "Colima"
        },
        {
            "id_pais": "1",
            "id_estado": "1-7",
            "nom_estado": "Chiapas"
        },
        {
            "id_pais": "1",
            "id_estado": "1-8",
            "nom_estado": "Chihuahua"
        },
        {
            "id_pais": "1",
            "id_estado": "1-9",
            "nom_estado": "Ciudad de México"
        }
    ] 
    let showMsgAlert=false
    let showMsgSend=false
    let txtMsgSend='-------------------'
    const pais = [
            {"id_pais":1,"nom_pais":"México"},
            {"id_pais":2,"nom_pais":"Estados Unidos"},
            {"id_pais":3,"nom_pais":"Guatemala"},
            {"id_pais":5,"nom_pais":"Honduras"},
            {"id_pais":7,"nom_pais":"Nicaragua"},
            {"id_pais":8,"nom_pais":"Costa Rica"},
            {"id_pais":6,"nom_pais":"El Salvador"},
            {"id_pais":9,"nom_pais":"Panamá"},
            {"id_pais":4,"nom_pais":"Belize"}
        ]
    let validate = {
        "nombre":{error:false,status:false},
        "apellidos":{error:false,status:false},
        "institucion":{error:false,status:false},
        "puesto":{error:false,status:false},
        "profesion":{error:false,status:false},
        "correo":{error:false,status:false},
        "correoCheck":{error:false,status:false,msg:'completa este campo'},
        "sel_pais":{error:false,status:false},
        "sel_estado":{error:false,status:false}
    }
    async function getPais(pais,nomPais){
        console.log('get_pais',pais,nomPais)
        let paramPais = pais.find((item) => item.nom_pais === nomPais) || '1';
        estadosResult=await getEstados({id:paramPais.id_pais})
        return paramPais.id_pais
    }
    function showSend(){
            showMsgSend=true
            for (const property in alerta) {
                alerta[property] = ""
            }
            for (const property in validate) {
                validate[property]['error'] = false
                validate[property]['status'] = false
            }
            getPais(pais,'México')
        setTimeout(function(){
            showMsgSend=false
        }, 4000);
    }
    function showAlert(){
            showMsgAlert=true
        setTimeout(function(){
            showMsgAlert=false
        }, 3000);
    }
    function checkStatus(param){
        let status=true;
        for (const property in param) {
            if(!param[property]['status']){
                status = false
                alerta[property] = null
            }
        }

        if(!status){showAlert()}
        return status
    }
    onMount(async () => {
        
    })
    </script>
    <style>

    </style>
    {#if !showMsgSend}
        <BlockTitle> NACIONALES </BlockTitle>
        <Block strong mediumInset style="text-align: justify;">
            <p>
                Este servicio envia notificaciones cuando se encuentra uno o mas puntos de calor en el estado seleccionado.
            </p>
            <strong>
                <p style="margin-top: 25px;color: var(--f7-table-footer-text-color);font-size: var(--f7-table-footer-font-size);">
                    La información personal proporcionada es sólo para fines estadísticos y sigue las políticas de privacidad y protección de datos de la Conabio.
                    <Link style="margin-top: 15px;"
                    iconSize="18px"
                    tooltip="{`
                        <span style="color:white">Aviso de privacidad</span>
                    `}"
                    iconIos="f7:info_circle_fill" iconAurora="f7:info_circle_fill" iconMd="f7:info_circle_fill"
                    on:click={()=>{
                        window.open("https://www.biodiversidad.gob.mx/conabio/proteccion-DP/ap-proteccion-datos","","titlebar=no");
                    }}/>
                </p>
            </strong>
            <p>
        <Link href="https://docs.google.com/forms/d/e/1FAIpQLSffI-lKcAVKul25vumfHRM2M0_SxDSKHK_cAt_rF0Lz_HLT4w/viewform?usp=header" target="_blank" external>
            <img src="static/png/alertas_registro.png" alt="Registro de Usuarios" width="595px;"/>
        </Link>
            </p>
            <!-- TEMPORAL COMMENT <List inlineLabels noHairlinesMd>
                <ListInput
                label="Nombre"
                type="text"
                bind:value={alerta.nombre}
                placeholder="Ingresa el nombre"
                required
                validate
                errorMessage="Completa este campo"
                errorMessageForce={validate.nombre.error}
                onInput={() => validate.nombre.error = false }
                onValidate={(isValid) => validate.nombre.status=isValid}
                clearButton
                >
                </ListInput>
                <ListInput
                label="Apellidos"
                type="text"
                bind:value={alerta.apellidos}
                required
                validate
                errorMessage="Completa este campo"
                errorMessageForce={validate.apellidos.error}
                onInput={() => validate.apellidos.error = false }
                onValidate={(isValid) => validate.apellidos.status=isValid}
                placeholder="Ingresa los apellidos"
                clearButton
                >
                </ListInput>
                <ListInput
                label="Institución"
                type="text"
                bind:value={alerta.institucion}
                required
                validate
                errorMessage="Completa este campo"
                errorMessageForce={validate.institucion.error}
                onInput={() => validate.institucion.error = false }
                onValidate={(isValid) => validate.institucion.status=isValid}
                placeholder="Ingresa la institución"
                clearButton
                >
                </ListInput>
                <ListInput
                label="Puesto"
                type="text"
                bind:value={alerta.puesto}
                required
                validate
                errorMessage="Completa este campo"
                errorMessageForce={validate.puesto.error}
                onInput={() => validate.puesto.error = false }
                onValidate={(isValid) => validate.puesto.status=isValid}
                placeholder="Ingresa el puesto"
                clearButton
                >
                </ListInput>
                <ListInput
                label="Profesión"
                type="text"
                bind:value={alerta.profesion}
                required
                validate
                errorMessage="Completa este campo"
                errorMessageForce={validate.profesion.error}
                onInput={() => validate.profesion.error = false }
                onValidate={(isValid) => validate.profesion.status=isValid}
                placeholder="Ingresa la profesión"
                clearButton
                >
                </ListInput>
                <ListInput
                label="Correo"
                type="email"
                bind:value={alerta.correo}
                required
                validate
                errorMessage="Completa este campo"
                errorMessageForce={validate.correo.error}
                onInput={() => validate.correo.error = false }
                onValidate={(isValid) => validate.correo.status=isValid}
                placeholder="Ingresa el correo"
                clearButton
                >
                
                </ListInput>
                <ListInput
                label="Confirmar Correo"
                type="email"
                bind:value={alerta.correoCheck}
                required
                validate
                errorMessage={validate.correoCheck.msg}
                errorMessageForce={validate.correoCheck.error}
                onInput={(val) => {
                    validate.correoCheck.error = false 
                    }}
                validateOnBlur={true}
                onBlur={(val) => {
                        if(alerta.correo!==alerta.correoCheck){
                            validate.correoCheck.msg="correo no coincide"
                            validate.correoCheck.error = true
                            validate.apellidos.status = false
                        }
                    }}
                onValidate={(isValid) => validate.correoCheck.status=isValid}
                placeholder="Ingresa el correo"
                clearButton
                >
                </ListInput>
                <p>Área de interés</p>
                <ListInput
                label="País"
                type="select"
                bind:value={alerta.sel_pais}
                required
                validate
                errorMessage="Completa este campo"
                errorMessageForce={validate.sel_pais.error}
                onInput={() => {
                    validate.sel_pais.error = false;
                }}
                onChange={async() => {
                    getPais(pais,alerta.sel_pais)
                }}
                onValidate={(isValid) => validate.sel_pais.status=isValid}
                placeholder="Ingresa el País"
                >
                <div slot="item-media" style="padding-bottom: 10px;"></div>
                
                {#each pais as {id_pais, nom_pais} (id_pais) }
                <option value="{nom_pais}">{nom_pais}</option>
                {/each}
              </ListInput>
              {#if estadosResult.length > 0}
                <ListInput
                label="Estado"
                type="select"
                bind:value={alerta.sel_estado}
                required
                validate
                errorMessage="Completa este campo"
                errorMessageForce={validate.sel_estado.error}
                onInput={() => validate.sel_estado.error = false }
                onValidate={(isValid) => validate.sel_estado.status=isValid}
                placeholder="Ingresa el Estado">
                <div slot="item-media" style="padding-bottom: 10px;"></div>
                <option value="Todo el Pais" selected>Todos</option>
                {#each estadosResult as {id_estado, nom_estado} (id_estado) }
                <option value="{nom_estado}">{nom_estado}</option>
                {/each}
                </ListInput>
               {/if}
               <li>
                <p style="color: rgba(255, 255, 255, 0.54);margin-left: 17px;">Deseo recibir información<br>en mi correo 
                  <Checkbox 
                    style="margin-left: 152px;" 
                    name="checkbox-2"
                    onChange={(e) => {
                        if(e.target.checked){
                            alerta.boletin = "Deseo recibir información"
                        }
                      }}
                    >
                  </Checkbox>
              </li>
                <ListInput
                type="textarea"
                bind:value={alerta.comentario}
                validate
                placeholder="Ingeresa los comentarios"
                clearButton
                >
                <div slot="label">Comentarios, sugerencias<br>o cancelación</div>
                </ListInput> 
            </List> TEMPORAL COMMENT-->
            </Block>

            <Block>
                {#if showMsgAlert}
                <Row style="text-align: center;">               
                    <Col >
                        <Chip text="Por favor ingresa los datos faltantes" color="red" />    
                    </Col>
                </Row>
                {:else}
                <Row>
                    <Col>
                    </Col>
                    <Col>
                    <!--<Button outline
                    on:click={async ()=>{
                        let result={}
                        if(checkStatus(validate)){
                            result = await getAlertas(alerta)
                            txtMsgSend=result.msg
                            showSend()
                        }else{
                            alerta.apellidos=''
                        }
                    }}
                    >Enviar</Button> -->
                    </Col>
                    <Col>
                    </Col>
                </Row>
                {/if}
            </Block>
    {:else}
        <BlockTitle> Mensaje Enviado </BlockTitle>
        <Block>
            <Row>               
                <Col>
                    <p>{txtMsgSend}</p>    
                </Col>
            </Row>
        </Block>

    {/if}


        